import React, { useEffect , useState } from "react";
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Col, Row } from "reactstrap";
import axios from "axios";
import Select, { components } from "react-select";

const MultiValueLabelWithTitle = props => (
  <components.MultiValueLabel {...props}>
    <span title={props.selectProps.selectedNamesTitle || props.data?.displayName || props.data?.name || ""}>{props.children}</span>
  </components.MultiValueLabel>
)

const SelectControlWithSelectedNamesTitle = props => (
  <components.Control
    {...props}
    innerProps={{
      ...props.innerProps,
      title: props.selectProps.selectedNamesTitle,
    }}
  />
)

const LinkContactsPopup = ({
  onSelectedJobsChange,
  errorJob,
  setSelectedScheduleContacts,
  setSelectedScheduleContactDetails,
  clearSelectedContactsSignal,
  setSelectedCcUsers,
  errorContact,
  clearInterviewerError,
  jobLabel,
  companyId,
  hideJobSelector = false,
  children,
}) => {
    const [jobDetailsVisible, setJobDetailsVisible] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [selectedJob, setSelectedJob] = useState(null); // Now single job
    const [lazyParams, setLazyParams] = useState({ page: 0, rows: 10 });
    const [jobs, setJobs] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [loading, setLoading] = useState(false);
    const [prioritycontact, setPrioritycontact] = useState([]);
    const [ccPrioritycontact, setCcPrioritycontact] = useState([]);
    const [dialogVisible, setDialogVisible] = useState(false);
    const [selectedContacts, setSelectedContacts] = useState([]);
    const [typeInterviewcontact, settypeInterviewcontact] = useState([]);
    const [selectedEmployees, setselectedEmployees] = useState(null);
    const [selectedCcEmployees, setSelectedCcEmployees] = useState(null);
    const [jobSearchText, setJobSearchText] = useState('');
    const [contactSearchText, setContactSearchText] = useState('');
    useEffect(() => {
        if (!clearSelectedContactsSignal) return;
        setSelectedContacts([]);
        setselectedEmployees([]);
        setSelectedScheduleContacts([]);
        setSelectedScheduleContactDetails?.([]);
    }, [clearSelectedContactsSignal]);




   const filteredJobs = (data) =>
    data.filter(job => {
        const q = jobSearchText.toLowerCase();
        return (
            job.title?.toLowerCase().includes(q) ||
            job.manager?.toLowerCase().includes(q) ||
            job.id?.toString().includes(jobSearchText)
        );
    });


    // const handleSave = () => {
    //     setJobDetailsVisible(false);
    //     setJobSearchText('');
    //     onSelectedJobsChange?.([selectedJob]); 
    // };
    const handleSave = () => {
  setJobDetailsVisible(false);
  setJobSearchText('');

  if (!selectedJob) {
    onSelectedJobsChange?.([]);   // 🔥 IMPORTANT
  } else {
    onSelectedJobsChange?.([selectedJob]);
  }
};


    const handleRefresh = () => {
        setSelectedJob(null);
        setSearchText('');
        onSelectedJobsChange?.([]);
    };

    const handleIconClick = () => {
        setJobSearchText('');
        setJobDetailsVisible(true);
    };
    const onPageChange = (event) => {
        setLazyParams({ page: event.page, rows: event.rows });
    };
    const userInfos = JSON.parse(sessionStorage.getItem("user-info"));
    const intialcompanyId = userInfos.user_details.companies_data[0].company_id;
    // const [companyId, setCompanyId] = useState(intialcompanyId);
    const getallactivejobs = async () => {
        setLoading(true);
        try {
            const page = lazyParams?.page ?? 0;
            const rows = lazyParams?.rows ?? 10;
            // const response = await axios.get(`/api/v1/jobs/?page=${page + 1}&size=${rows}&status=Approved / Open&company_id=${companyId}`, {});
            const response = await axios.get(`/api/v1/create-job-order/?page=${page + 1}&size=${rows}&company_id=${companyId}`, {});
            if (response.status === 200) {
                const transformedData = response.data.results.map((cond) => ({
                    title: cond.job_title ?? '',
                    id: cond.job_id ?? '',
                    manager: cond.hiring_manager_name ?? '',
                    job_number: cond.job_number ?? '',
                    recruiters_names: cond.recruiters_names ?? []
                }));
                setJobs(transformedData);
                setTotalRecords(response.data.count || 0);
            } else {
                setJobs([]);
                setTotalRecords(0);
            }
        } catch (error) {
            console.error('Error fetching jobs:', error);
        }
        finally {
        setLoading(false); 
    }
    };
    useEffect(() => {
        getInterviewerContacts();
        if (companyId && companyId !== "All") {
            if (!hideJobSelector) {
              getallactivejobs();
            }
            getCcManagerContacts()
        } else {
            setPrioritycontact([]);
            settypeInterviewcontact([]);
            setCcPrioritycontact([]);
            setSelectedCcEmployees(null);
            setselectedEmployees(null);
        }
    }, [lazyParams.page, lazyParams.rows,companyId]);
    useEffect(() => {
  setSelectedJob(null);
  setSelectedContacts([]);
  setselectedEmployees(null);
  setSelectedCcEmployees(null);
  setSelectedCcUsers?.([]);
}, [companyId]);


    const handleIconClickContact = () => {
        setDialogVisible(true);
    };
    const closeDialogContact = () => {
        setContactSearchText('');
        setDialogVisible(false);
    };

    const handleSaveContact = () => {
        const selectedIds = selectedContacts.map((contact) => contact.id);
        setPrioritycontact(selectedContacts.map((contact) => contact.name).join(', '));
        setSelectedScheduleContacts(selectedIds);
        setSelectedScheduleContactDetails?.(selectedContacts);
        setDialogVisible(false);
    };

    // const getallactivecontacts = async () => {
    //     try {
    //         const response = await axios.get(`/api/v1/get-all-hiring-managers/`, {});
    //         const transformedData = response.data.results.map((contact) => ({
    //             name: contact.first_name,
    //             id: contact.id || contact.user_id
    //         }));
    //         settypeInterviewcontact(transformedData);
    //     } catch (error) {
    //         console.error('Error fetching contacts:', error);
    //     }
    // };
const [loadingContacts,setLoadingContacts] = useState(true)
    const getInterviewerContacts = async () => {
        if (!companyId || companyId === "All") {
            setPrioritycontact([]);
            settypeInterviewcontact([]);
            setLoadingContacts(false);
            return;
        }
        setLoadingContacts(true);
        try {
            const response = await axios.get(
                `/api/v1/contacts/?page=1&size=1000&status=Active`
            );
            const managers = response.data?.results || response.data || [];
            const transformedData = managers.map(contact => ({
                name: `${contact.first_name || ""} ${contact.middle_name || ""} ${contact.last_name || ""}`.trim()
                  || contact?.contact_name
                  || contact?.first_name
                  || "",
                displayName: (() => {
                  const name = `${contact.first_name || ""} ${contact.middle_name || ""} ${contact.last_name || ""}`.trim()
                    || contact?.contact_name
                    || contact?.first_name
                    || "";
                  const companyDomain = contact?.company_domain || contact?.company?.company_domain;
                  if (!companyDomain) return name || "--";
                  return `${name || "--"} - ${companyDomain}`;
                })(),
                companyDomain: contact?.company_domain || contact?.company?.company_domain || "",
                contactEmail: contact?.email || contact?.work_email || contact?.contact_email || "",
                id: contact?.id || contact?.contact_id || contact?.user_id,
                email: contact?.email || contact?.work_email || contact?.contact_email || "",
            }));
            setPrioritycontact(transformedData);
            settypeInterviewcontact(transformedData);
        } catch (error) {
            console.error("Error fetching interviewer contacts:", error);
        } finally {
            setLoadingContacts(false);
        }
    };
    const getCcManagerContacts = async () => {
        if (!companyId || companyId === "All") {
            setCcPrioritycontact([]);
            setSelectedCcEmployees(null);
            setSelectedCcUsers?.([]);
            return;
        }
        try {
            const response = await axios.get(
                `/api/v1/get-all-hiring-managers/`
            );
            const managers = response.data?.results || response.data || [];
            const transformedData = managers.map(contact => ({
                name: `${contact.first_name || ""} ${contact.middle_name || ""} ${contact.last_name || ""}`.trim() || contact?.first_name || "",
                id: contact?.id || contact?.contact_id,
                email: contact?.email || contact?.work_email || "",
            }));
            setCcPrioritycontact(transformedData);
        } catch (error) {
            console.error("Error fetching CC contacts:", error);
        }
    };
    // useEffect(() => {
    //     getallactivecontacts1();
    // }, [companyId]);

   const filteredContacts = typeInterviewcontact?.filter(candidate =>
    candidate.name?.toLowerCase().includes(contactSearchText.toLowerCase()) ||
    candidate.id?.toString().includes(contactSearchText) ||
    candidate.displayName?.toLowerCase().includes(contactSearchText.toLowerCase()) ||
    candidate.contactEmail?.toLowerCase().includes(contactSearchText.toLowerCase())
);

    return (
        <>
            {!hideJobSelector && (
              <Col lg={6} style={{ order: 3 }}>
                  <div className="field">
                      <label htmlFor="job" className="block">{jobLabel}</label>
                      <div className="d-flex align-items-center" style={{ position: 'relative' }}>
                          <InputText
                              id="job"
                              value={selectedJob ? `${selectedJob.title}, ${selectedJob.job_number}` : ''}
                              placeholder="Select Job"
                              className="w-full"
                              style={{ paddingRight: '2rem', cursor: "pointer" }}
                              // readOnly
                              onClick={handleIconClick}
                          />
                          <i
                              className="pi pi-chevron-down"
                              onClick={handleIconClick}
                              style={{
                                  position: 'absolute',
                                  right: '10px',
                                  top: '50%',
                                  transform: 'translateY(-50%)',
                                  cursor: 'pointer'
                              }}
                          ></i>
                      </div>
                      <Dialog
                          header="Link Jobs"
                          visible={jobDetailsVisible}
                          onHide={() => setJobDetailsVisible(false)}
                          style={{ width: '40vw' }}
                          breakpoints={{ '960px': '75vw', '641px': '100vw' }}
                          className="cand-details"
                      >
                          <Row>
                              <Col lg={12}>
                                  <div className="p-inputgroup mb-3" style={{ position: 'relative' }}>
                                     <InputText
                                      placeholder="Search Jobs"
                                      value={jobSearchText}
                                      onChange={(e) => setJobSearchText(e.target.value)}
                                      style={{ paddingRight: '2rem' }}
                                  />

                                      <i
                                          className="pi pi-search"
                                          style={{
                                              position: 'absolute',
                                              right: '10px',
                                              top: '49%',
                                              transform: 'translateY(-50%)',
                                          }}
                                      ></i>
                                  </div>
                              </Col>
                          </Row>
                          <DataTable
                              value={filteredJobs(jobs)}
                              selection={selectedJob}
                              onSelectionChange={(e) => setSelectedJob(e.value)}
                              dataKey="id"
                              size="small"
                              scrollable
                              scrollHeight="320px"
                              id="AllEmployees_TableView"
                              lazy paginator first={lazyParams.page * lazyParams.rows}
                              rows={lazyParams.rows} totalRecords={totalRecords} onPage={onPageChange} loading={loading}
                              paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                              currentPageReportTemplate="{first} to {last} of {totalRecords}"
                              rowsPerPageOptions={[10, 20, 50, totalRecords]}
                          >
                              <Column selectionMode="single" style={{ width: '3em' }} />
                              <Column field="job_number" header="Job ID" />
                              <Column field="title" header="Job Title" />
                             <Column
                                  field="manager"
                                  header="Contact"
                                  body={(rowData) => {
                                      const names = rowData.recruiters_names;

                                      if (!names || names.length === 0) return "--";

                                      const text = names.join(", ");

                                      return (
                                      <span
                                          title={text}
                                          style={{
                                          maxWidth: '180px',      
                                          display: 'inline-block',
                                          whiteSpace: 'nowrap',
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          verticalAlign: 'middle',
                                          cursor: 'pointer'
                                          }}
                                      >
                                          {text}
                                      </span>
                                      );
                                  }}
                                  style={{ width: '180px' }}  
                                  />

                          </DataTable>
                          <div className="d-flex mt-3 justify-content-center">
                              <button type="button" className="btn btn-primary me-2 btn-main" onClick={handleSave}>Save</button>
                              <button type="button" className="btn btn-primary btn-main" onClick={handleRefresh}>Refresh</button>
                          </div>
                      </Dialog>
                      {errorJob && <p className="p-error">{errorJob}</p>}
                  </div>
              </Col>
            )}
            <Col xl={6} style={{ order: 1 }}>
                <div className={`p-field flex flex-column ${hideJobSelector ? "mt-3" : ""}`}>
                    <label htmlFor="contact" className="block">
                        Interviewer <span className="text-danger">*</span>
                    </label>
                    <div className="d-flex align-items-center" style={{ position: 'relative' }}>
                        <Select
                            id="company"
                            value={selectedEmployees || []}
                            options={prioritycontact}
                            onChange={(value) => {
                                const nextSelectedEmployees = value || [];
                                setselectedEmployees(nextSelectedEmployees);
                                const selectedIds = nextSelectedEmployees.map((item) => item.id);
                                setSelectedScheduleContacts(selectedIds);
                                setSelectedScheduleContactDetails?.(nextSelectedEmployees);
                                if (nextSelectedEmployees.length) {
                                  clearInterviewerError?.();
                                }
                            }}
                            placeholder="Select Interviewer"
                            getOptionLabel={option => option.displayName || option.name || "--"}
                            getOptionValue={option => String(option.id)}
                            isMulti
                            isSearchable
                            isClearable
                            isLoading={loadingContacts}
                            closeMenuOnSelect={false}
                            className="w-full"
                            classNamePrefix="link-contacts-select"
                            components={{
                              Control: SelectControlWithSelectedNamesTitle,
                              MultiValueLabel: MultiValueLabelWithTitle,
                            }}
                            selectedNamesTitle={(selectedEmployees || []).map(emp => emp.displayName || emp.name || "--").join(", ") || "Select Interviewer"}
                        />
                    </div>
                    {errorContact && <p className="p-error">{errorContact}</p>}
                </div>
            </Col>
            {children}
            <Col xl={6} style={{ order: 2 }}>
                <div className={`p-field flex flex-column ${hideJobSelector ? "mt-3" : ""}`}>
                    <label htmlFor="ccUsers" className="block">
                        Select Manager(s)
                    </label>
                    <Select
                        id="ccUsers"
                        value={selectedCcEmployees || []}
                        options={ccPrioritycontact}
                        onChange={(value) => {
                            const nextSelectedCcEmployees = value || [];
                            setSelectedCcEmployees(nextSelectedCcEmployees);
                            setSelectedCcUsers?.(
                              nextSelectedCcEmployees
                                .map((item) => item.email)
                                .filter(Boolean)
                            );
                        }}
                        placeholder="Select Managers"
                        getOptionLabel={option => option.name || "--"}
                        getOptionValue={option => String(option.id)}
                        isMulti
                        isSearchable
                        isClearable
                        isLoading={loadingContacts}
                        closeMenuOnSelect={false}
                        className="w-full"
                        classNamePrefix="link-contacts-select"
                        components={{
                          Control: SelectControlWithSelectedNamesTitle,
                          MultiValueLabel: MultiValueLabelWithTitle,
                        }}
                        selectedNamesTitle={(selectedCcEmployees || []).map(emp => emp.name || "--").join(", ") || "Select Managers"}
                    />
                </div>
            </Col>
        </>
    );
};

export default LinkContactsPopup;
